// The warranty permissions the OMS puts in selfInfo.user.permissions (a list of strings).
// A convenience for the menu and the screens: the OMS refuses every call without the permission.
export const WARRANTY_PERMISSION = {
  PLANS_ADMIN: "warranty_plans_admin",
  OPS: "warranty_ops",
  REVIEW: "warranty_review",
  // 27 Oct 2026 (Sachin): read only, All warranties and Assure customers and nothing else. The OMS
  // opens only those read routes for it; every action still needs review or ops.
  VIEW: "warranty_view",
};

export const hasWarrantyPermission = (selfInfo, permission) => {
  const user = selfInfo?.user;
  if (user?.user_type === "super_admin") {
    return true;
  }
  const granted = user?.permissions;
  if (!Array.isArray(granted)) {
    return false;
  }
  return granted.some(
    (item) => typeof item === "string" && item.trim() === permission
  );
};

// True when the user holds any one of `permissions`.
export const hasOneOfWarrantyPermissions = (selfInfo, permissions) =>
  permissions.some((permission) => hasWarrantyPermission(selfInfo, permission));

export const hasAnyWarrantyPermission = (selfInfo) =>
  Object.values(WARRANTY_PERMISSION).some((permission) =>
    hasWarrantyPermission(selfInfo, permission)
  );
